import { combineReducers } from 'redux';
import { user } from './user/user_reducer';
import { appointments } from './appointments/appointments_reducer';
import { customers } from './customer/customer_reducer';
import { workers } from './worker/worker_reducer';
import { places } from './place/place_reducer';
import { articles } from './article/article_reducer';
import { percentages } from './percentage/percentage_reducer';
import { areas } from './area/area_reducer';
import { subAreas } from './sub_area/sub_area_reducer';
import { therapies } from './therapy/therapy_reducer';
import { dailyReports } from './reports/daily_reports_reducer';
import { workerReports } from './reports/worker_reports_reducer';
import { yearlyReports } from './reports/yearly_reports_reducer';
import { graphAnalytics } from './reports/graph_analytics_reducer';
import { expenses } from './expense/expense_reducer';
import { expenseTypes } from './expense_type/expense_type_reducer';
import { mlps } from './mlp/mlp_reducer';
import { protocols } from './protocols/protocols_reducer';

export default combineReducers({
  user,
  appointments,
  customers,
  workers,
  places,
  articles,
  percentages,
  areas,
  subAreas,
  therapies,
  dailyReports,
  workerReports,
  yearlyReports,
  graphAnalytics,
  expenses,
  expenseTypes,
  mlps,
  protocols
});
